import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M65.3 17.032H0.299988V33.664H65.3V17.032Z" fill="black" />
    <path d="M65.3 33.664H0.299988V50.4H65.3V33.664Z" fill="white" />
    <path d="M65.3 0.399994H0.299988V17.032H65.3V0.399994Z" fill="#0052B4" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
